export const coreConfig = {
    debounceTimeClick: 300,
    debounceTimeTyping: 660,
    externalScriptLoadDelay: 7500,
    debounceTimeWithApiConnection: 3000,
};
